import React from 'react';
import { ApplicationType } from '../../../common/platform/platformTypes';
import { useSelector } from 'react-redux';
import { getApplicationTypeSelector } from '../platformSelector';

type PlatformSwitchProps = {
    components: Partial<Record<ApplicationType | 'default', React.FC | React.ComponentClass | null>>;
};

/**
 * Switch component that renders a different children based on the application type.
 * @param components - A mapping of ApplicationType or 'default' to React elements.
 */
const ApplicationTypeSwitch = ({ components }: PlatformSwitchProps): React.ReactElement | null => {
    const applicationType = useSelector(getApplicationTypeSelector);

    const Component = components[applicationType] || components.default;
    if (!Component) return null;

    return <Component />;
};

export default ApplicationTypeSwitch;
